<div [class]="getStatusClass(modelRiscosChaves)">
  <app-print-layout (cancelar)="onBack()">
    <div class="container card card-outline">
      <div class="subtitulo">
        <strong>RISCOS CHAVES - {{nomeRiscoChaves}}</strong><br />
        <strong>Versäo: {{ versao }} </strong>
        <br />
        <strong>Data: {{ dataCriacaoFormatada }}</strong>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="mat-elevation-z8">
            <table class="mat-elevation-z8 w-100 table table-bordered">
              <thead>
              <tr>
                <th>Subtipo</th>
                <th>Macroprocesso</th>
                <th>Processos</th>
                <th>Descrição do Risco-Chave</th>
                <th>Magnitude (Risco Inerente)</th>
                <th>Magnitude (Risco Residual)</th>
<!--                <th>Ações</th>-->
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let subtipo of modelTipoUniversoItens?.itens">
                <tr class="tr-cinza">
                  <td><strong>{{ subtipo.ordemExibicao }} {{ subtipo.nome }}</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
<!--                  <td></td>-->
                </tr>

                <ng-container *ngFor="let macro of subtipo.itens">
                  <ng-container *ngIf="macro.tipo === 2">
                    <tr>
                      <td></td>
                      <td><strong>{{ macro.ordemExibicao }} {{ macro.nome }}</strong></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
<!--                      <td></td>-->
                    </tr>

                    <ng-container *ngIf="getMagnitude(macro.itens) as magnitude">
                      <ng-container *ngFor="let processo of macro.itens">
                        <ng-container *ngIf="getRiscosPorProcesso(processo.id) as riscos">
                          <ng-container *ngFor="let risco of riscos; let i = index">
                            <tr>
                              <td></td>
                              <td></td>

                              <ng-container *ngIf="i === 0">
                                <td [attr.rowspan]="riscos.length">
                                  {{ processo.ordemExibicao }} {{ processo.nome }}
                                </td>
                              </ng-container>

                              <td>{{ risco.nomeRisco }}</td>
                              <td>{{ risco.ri || 0 }}</td>
                              <td>{{ risco.rr || 0 }}</td>
                            </tr>
                          </ng-container>
                          <ng-container *ngIf="getMagnitude([processo]) as magProc">
                            <tr>
                              <td></td>
                              <td></td>
                              <td colspan="2" class="text-left"><strong>Magnitude</strong></td>
                              <td><strong>{{ magProc.riTotal }}</strong></td>
                              <td><strong>{{ magProc.rrTotal }}</strong></td>
<!--                              <td></td>-->
                            </tr>
                          </ng-container>
                        </ng-container>
                      </ng-container>
                      <tr>
                        <td></td>
                        <td colspan="3" class="text-left"><strong>Magnitude</strong></td>
                        <td><strong>{{ magnitude.riTotal }}</strong></td>
                        <td><strong>{{ magnitude.rrTotal }}</strong></td>
<!--                        <td></td>-->
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="getMagnitudeMacro(subtipo.itens) as magnitudeSubtipo">
                  <tr>
                    <td></td>
                    <td colspan="3" class="text-left"><strong>Magnitude</strong></td>
                    <td><strong>{{ magnitudeSubtipo.riTotal }}</strong></td>
                    <td><strong>{{ magnitudeSubtipo.rrTotal }}</strong></td>
<!--                    <td></td>-->
                  </tr>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="getMagnitudeTotal() as magnitudeTotal">
                <tr>
                  <td><strong>Magnitude</strong></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td><strong>{{ magnitudeTotal.riTotal }}</strong></td>
                  <td><strong>{{ magnitudeTotal.rrTotal }}</strong></td>
<!--                  <td></td>-->
                </tr>
              </ng-container>

            </table>

          </div>
        </div>
      </div>
    </div>
  </app-print-layout>
</div>



